import React, { useReducer, useState, useEffect } from 'react';
import style from './EditCarriagePalette.module.css';
import axios from '../../functions/axios';
import { throttle } from '../../functions/functions';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { DatePicker, Localization } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import moment from 'moment';
import DropdownList from 'react-widgets/DropdownList';
import { parseDate } from '../../functions/functions';

function EditCarriage() {
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {
    day: location.state.carriage?.day || parseDate(),
    routeStart: location.state.carriage?.routeStart || '',
    routeEnd: location.state.carriage?.routeEnd || '',
    invoice: location.state.carriage?.invoice,
    paletteExchanged: location.state.carriage?.paletts?.paletteExchanged || 0,
    paletteLoad: location.state.carriage?.paletts?.paletteLoad || 0,
    paletteLeft: location.state.carriage?.paletts?.paletteLeft || 0,
    paletteTaken: location.state.carriage?.paletts?.paletteTaken || 0,
    paletteExchangedDD: location.state.carriage?.paletts?.paletteExchangedDD || 0,
    paletteLoadDD: location.state.carriage?.paletts?.paletteLoadDD || 0,
    paletteLeftDD: location.state.carriage?.paletts?.paletteLeftDD || 0,
    paletteTakenDD: location.state.carriage?.paletts?.paletteTakenDD || 0,
    paletteBallanceDD: location.state.client.paletteBallanceDD,
    paletteBallanceE: location.state.client.paletteBallanceE,
    paletteBalDD: location.state.carriage?.paletts?.paletteBalDD || 0,
    paletteBalE: location.state.carriage?.paletts?.paletteBalE || 0,
    clientId: location.state.client._id,
  });
  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const { user } = useAuthContext();

  useEffect(() => {
    if (!user) return null;
    Promise.all([getData('/driver', setDrivers), getData('/car', setCars)]);
  }, [user]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    (async () => {
      if (!user || !formData.invoice) return null;
      await throttle(1000);
      try {
        const response = await axios.get(`/carriage`, {
          params: {
            populate: ['paletts','paletts.creator'],
            limit: 10,
            invoice: formData.invoice,
          },
          cancelToken: source.token,
        });
        if (response.data.length === 1) {
          const [current] = response.data;
          handleChange({ target: { name: 'day', value: current?.day } });
          handleChange({ target: { name: 'car', value: current?.car?.plate } });
          handleChange({ target: { name: 'driver', value: current?.driver?.name } });
          handleChange({ target: { name: 'routeStart', value: current?.routeStart } });
          handleChange({ target: { name: 'routeEnd', value: current?.routeEnd } });
        }
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log('axios request canceled');
          return;
        }
        console.log(err);
      }
    })();

    return () => {
      source.cancel();
    };
  }, [formData.invoice]);

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    await axios.patch(`/paletts`, { ...formData, _id: location.state.carriage?.paletts?._id });

    await setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/carriagePaletteList', { state: { client: location.state.client } });
  };

  const handleDelete = async (event) => {
    if (event.target.id !== 'remove') return;
    event.preventDefault();
    event.stopPropagation();
    const confirmBox = window.confirm("Czy chcesz usunąć te dane ?");
    if (confirmBox) {
      await axios.delete(`/paletts`, {
        data: {
          _id: location.state.carriage?.paletts?._id
        },
      });
    }
    navigate('/carriagePaletteList', { state: { client: location.state.client } });
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  return (
    <div className={style.wrapper}>
      <form>

        <div className={style.section}>
          <h2>Edycja Palety</h2>
          <div>
          <p className={style.category2}>Utworzył: {location.state.carriage.paletts?.creator?.userName} o {location.state?.carriage?.paletts?.createdAt && new Date(location.state?.carriage?.paletts?.createdAt).toLocaleString('pl')}</p>
          {location.state?.carriage?.lastEdited?.userName && <p>Edytował: {location.state?.carriage?.paletts?.lastEdited?.userName} o {location.state?.carriage?.paletts?.updatedAt && new Date(location.state?.carriage?.paletts?.updatedAt).toLocaleString('pl')}</p>}
        </div>
          <br />
          <div className={style.row}>
            <label className={style.category} htmlFor='invoice-data'>
              Faktura
            </label>
            <input id='invoice-data' type='text' name='invoice' onChange={handleChange} value={formData.invoice ?? location.state.carriage?.invoice ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.category} htmlFor='day'>
              Data
            </label>
            {parseDate(formData.day).day.toLocaleDateString('pl',{weekDay:'long'})}
          </div>
        {/* </div>
        <div className={style.section}> */}
          <div className={style.row}>
            <label className={style.category} htmlFor='car-data'>
              Pojazd:
            </label>
            {formData.car}
          </div>
        {/* </div>
        <div className={style.section}> */}
          <div className={style.row}>
            <label className={style.category} htmlFor='driver-data'>
              Kierowca:
            </label>
            {formData.driver}
          </div>
        </div>
        <hr />

        <div className={style.section}>
        <div className={style.category}>Opis trasy</div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-start-data'>
              Skąd:
            </label>
            {formData.routeStart || ''}
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='route-end-data'>
              Dokąd:
            </label>
            {formData.routeEnd || ''}
          </div>

          <hr />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletts0'>wymienione EUR:</label>
            <input id='paletts0' type='number' name='paletteExchanged' onChange={handleChange} value={formData.paletteExchanged ?? location.state.carriage?.paletts?.paletteExchanged ?? ''} />
            <label className={style.subcategory} htmlFor='paletts1'>wymienione DD:</label>
            <input id='paletts1' type='number' name='paletteExchangedDD' onChange={handleChange} value={formData.paletteExchangedDD ?? location.state.carriage?.paletts?.paletteExchangedDD ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletts2'>załadowane EUR:</label>
            <input id='paletts2' type='number' name='paletteLoad' onChange={handleChange} value={formData.paletteLoad ?? location.state.carriage?.paletts?.paletteLoad ?? ''} />
            <label className={style.subcategory} htmlFor='paletts3'>załadowane DD:</label>
            <input id='paletts3' type='number' name='paletteLoadDD' onChange={handleChange} value={formData.paletteLoadDD ?? location.state.carriage?.paletts?.paletteLoadDD ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletts4'>odebrane EUR:</label>
            <input id='paletts4' type='number' name='paletteTaken' onChange={handleChange} value={formData.paletteTaken ?? location.state.carriage?.paletts?.paletteTaken ?? ''} />
            <label className={style.subcategory} htmlFor='paletts5'>odebrane DD:</label>
            <input id='paletts5' type='number' name='paletteTakenDD' onChange={handleChange} value={formData.paletteTakenDD ?? location.state.carriage?.paletts?.paletteTakenDD ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='paletts6'>zdane EUR:</label>
            <input id='paletts6' type='number' name='paletteLeft' onChange={handleChange} value={formData.paletteLeft ?? location.state.carriage?.paletts?.paletteLeft ?? ''} />
            <label className={style.subcategory} htmlFor='paletts7'>zdane DD:</label>
            <input id='paletts7' type='number' name='paletteLeftDD' onChange={handleChange} value={formData.paletteLeftDD ?? location.state.carriage?.paletts?.paletteLeftDD ?? ''} />
          </div>

          <div className={style.row}>
            <label className={style.subcategory} htmlFor='palleten11'>Saldo palet EURO:</label>
            <input id='palleten11' type='number' name='paletteBalE' onChange={handleChange} value={formData.paletteBalE ?? location.state.carriage?.paletts?.paletteBalE ?? 0} />
            <label className={style.subcategory} htmlFor='palleten12'>Saldo palet DD:</label>
            <input id='palleten12' type='number' name='paletteBalDD' onChange={handleChange} value={formData.paletteBalDD ?? location.state.carriage?.paletts?.paletteBalDD ?? 0} />
          </div>
        </div>
        <hr />
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='palleten9'>Saldo klienta palet EURO:</label>
          <input id='palleten9' type='number' name='paletteBallanceE' onChange={handleChange} value={formData.paletteBallanceE ?? location.state?.client.paletteBallanceE ?? 0} />
          <label className={style.subcategory} htmlFor='palleten10'>Saldo klienta palet DD:</label>
          <input id='palleten10' type='number' name='paletteBallanceDD' onChange={handleChange} value={formData.paletteBallanceDD ?? location.state?.client.paletteBallanceDD ?? 0} />
        </div>
        <hr />
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='receipe'>
            Kwit?
          </label>
          <input id='receipe' type='checkbox' name='receipe' onChange={handleChange} checked={formData?.receipe ?? location.state.carriage?.paletts?.receipe} />
        </div>
        <hr />
        <div className={style.category}>Uwagi:</div>
        <div className={style.row}>
          <textarea className={style.textData} id='comments-data' name='comments' onChange={handleChange} value={formData.comments ?? location.state.carriage?.paletts?.comments ?? ''} />
        </div>
        <hr />
        <div className={style.section}>
        </div>
        <hr />
        <span className={style.buttons}>
          <button id='cancel' className='btn btn-default' onClick={navigate.bind(null, '/carriagePaletteList', { state: { date: formData.day, client: location.state.client } })}>Anuluj</button>
          <button id='remove' className='btn btn-danger' onClick={handleDelete}>Usuń dostawę</button>
          <button id='submit' className='btn btn-default' type='submit' onClick={handleSubmit}>Zapisz</button>
        </span>
      </form>
    </div>
  );
}

const getData = async (path, callback) => {
  try {
    const { data: response } = await axios.get(path) || [];
    response.sort((...args) => {
      const [a, b] = args.map(({ name, plate, companyName }) => name || plate || companyName);
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
    callback(response);
  } catch (error) {
    console.error(error.message);
  }
};


export default EditCarriage;
